import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from "react";
import cn from "clsx";
import ArrowIosUp from "@crehana/icons/outline/ArrowIosUp";
import { transition } from "@crehana/ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MenuDesktopLink = function MenuDesktopLink(_ref) {
  var children = _ref.children,
    isSelected = _ref.isSelected,
    isDark = _ref.isDark,
    tourSelector = _ref.tourSelector,
    _ref$expandable = _ref.expandable,
    expandable = _ref$expandable === void 0 ? false : _ref$expandable,
    dataTestId = _ref.dataTestId,
    onClickItem = _ref.onClickItem,
    RightIcon = _ref.rightIcon,
    isBottomLink = _ref.isBottomLink,
    _ref$isSidebarV2Enabl = _ref.isSidebarV2Enabled,
    isSidebarV2Enabled = _ref$isSidebarV2Enabl === void 0 ? false : _ref$isSidebarV2Enabl;
  var _useState = useState(isSelected),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useEffect(function () {
    if (!isSelected) setIsOpen(false);
  }, [isSelected]);
  var onClick = useCallback(function () {
    setIsOpen(function (prev) {
      return !prev;
    });
    if (expandable) onClickItem();
  }, [expandable, onClickItem]);
  var classNames = cn('relative z-4 px-8 mx-12 rounded-5', isBottomLink ? 'tw-py-0.8' : 'tw-py-1.2', isDark ? 'hover:bg-gray-lighter-dark-mode' : 'hover:bg-gray-lighter', {
    'tw-flex tw-items-center tw-justify-between': expandable || !!RightIcon,
    'tw-bg-neutral-light-300 shadow-tooltip': isSelected && !isDark,
    'bg-base-lighter-dark-mode': isSelected && isDark
  });
  var sidebarV2ClassNames = cn('tw-relative z-4 tw-px-0.8 tw-mx-1.2 tw-rounded-[5px]', isBottomLink ? 'tw-py-0.8' : 'tw-py-1.2', isDark ? 'hover:bg-gray-lighter-dark-mode' : 'hover:bg-gray-lighter', {
    'tw-flex tw-items-center tw-justify-between': expandable || !!RightIcon,
    'tw-bg-neutral-dark-200 dark:tw-bg-elevation-dark-02': isSelected && !expandable,
    'tw-bg-neutral-light-200 dark:tw-bg-elevation-dark-02': isSelected && expandable
  });
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: cn('tw-w-full sm:min-w-212', isBottomLink ? 'tw-my-[2px]' : 'tw-my-0.4'),
    "data-tour": tourSelector,
    "aria-expanded": expandable && isOpen,
    "data-testid": dataTestId,
    onClick: onClick,
    children: /*#__PURE__*/_jsxs("div", {
      className: isSidebarV2Enabled ? sidebarV2ClassNames : classNames,
      style: {
        transition: transition(['background-color', 'box-shadow'])
      },
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-flex tw-items-center tw-w-full tw-cursor-pointer focus:outline-none",
        children: children
      }), RightIcon && /*#__PURE__*/_jsx(RightIcon, {
        size: 24,
        className: "tw-fill-current",
        ignoreColor: true
      }), expandable && /*#__PURE__*/_jsx("div", {
        className: "tw-w-2.4 tw-h-2.4",
        style: {
          transform: "rotate(".concat(isOpen ? '0deg' : '180deg', ")"),
          transition: transition('transform', 300)
        },
        "aria-hidden": true,
        children: isSidebarV2Enabled ? /*#__PURE__*/_jsx(ArrowIosUp, {
          size: 20,
          ignoreColor: true,
          className: cn('tw-fill-current', isSelected && 'tw-text-neutral-dark-700 dark:tw-text-neutral-dark-300')
        }) : /*#__PURE__*/_jsx(ArrowIosUp, {
          size: 24,
          ignoreColor: true,
          className: cn('tw-fill-current', isSelected && 'text-gray-dark')
        })
      })]
    })
  });
};
export default MenuDesktopLink;